import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogActions,
  DialogDescription,
  DialogTitle,
} from "V2.0/common/dialog";
import { deleteContact } from "..";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils/showErrorToast";

export function DeleteContact(props) {
  const { fetchContacts, projectId, open, onClose, contact } = props;

  const onDelete = async () => {
    try {
      const response = await deleteContact({
        projectId,
        contactId: contact._id,
      });

      if (response.status === 200) {
        message.success("Contact deleted");
        fetchContacts(projectId);
        onClose();
      }
    } catch (error) {
      showErrorToast(error, "Failed to delete contact");
    }
  };

  return (
    open && (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Delete Contact?</DialogTitle>
        <DialogDescription>
          Do you want the delete the contact {contact.phone}
        </DialogDescription>
        <DialogActions>
          <Button outline onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onDelete}>Yes, delete</Button>
        </DialogActions>
      </Dialog>
    )
  );
}
